export class RequestResult {
  constructor(
    public success: boolean,
    public messages: string[]
  ) {}
}
